import React from 'react'

export default function SubheaderDivider(props) {
  const {
    order,
    name,
    toggleButton = false,
    toggleSection = false,
    onToggle = () => { }
  } = props;

  let styleClass = '';

  if (order !== 1) {
    styleClass = 'divider mt-2 mb-2'
  }

  return (
    <div className="column is-full py-2">
      <div className={styleClass} />
      <p className="subtitle is-4 has-text-weight-bold">
        {name}
        {toggleButton && <span className="link-text ml-1" onClick={onToggle}>{toggleSection ? "Hide" : "Show..."}</span>}
      </p>
    </div>
  )
}
